import {useCallback, useState} from "react";
import {apiV2} from "../../api/axiosConfig";
import {noop} from "../misc/noop";
import {isAxiosError} from "axios";

type useSendResetLinkReturnType = [
    func: () => Promise<void>,
    sending: boolean,
    error: string | null,
]

export const useSendResetLink = (id: string, onSuccess: () => void = noop): useSendResetLinkReturnType => {

    const [sending, setSending] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const func = useCallback(async () => {
        setSending(true);
        setError(null);

        await apiV2.post("send-password-reset", {userID: id})
            .then(onSuccess)
            .catch((e) => {
                const message = isAxiosError(e) ? e.response?.data?.error : null;
                setError(message ?? "Error sending reset link");
            })
            .finally(() => setSending(false))

    }, [id, sending, setSending]);

    return [func, sending, error]


}